import Avatar from "react-avatar";
import TrophyIcon from "./TrophyIcon";

export default function TopReferralCard({ name, img, count, position }) {
  return (
    <div className="TopReferralCard">
      <div>
        <Avatar round={true} name={name} size="80" src={img} textSizeRatio={3} />
        <TrophyIcon position={position} />
      </div>

      <span>{name}</span>
      <span>{count} referrals</span>
    </div>
  );
}
